"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioB2C = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _index = require("../space/index");
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _excluded = ["className", "name", "form", "label", "options", "disabled", "errorMessage", "optional", "helper", "required"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var StyledRadioB2CDiv = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1az77c2-0"
})(["input[type=radio]{position:absolute;opacity:0;&:not(:checked) + label{font-weight:500;}&:checked + label,&:focus + label{", " ", "}}label{display:flex;align-items:flex-start;", " border-radius:8px;box-sizing:border-box;padding:10px 26px;", " ", "}option{display:none;}"], _kDsFoundation["default"].setColorTokenWithFallback('background: ', 'interactive-primary-light-bg'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'interactive-primary'), _kDsFoundation["default"].setColorTokenWithFallback('border: 1px solid ', 'border'), _kDsFoundation["default"].setColorWithFallback('background: ', 'white'), _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-secondary'));
var InputWrapper = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  componentId: "kds-v1__sc-1az77c2-1"
})(["position:relative;.helper-error{", " ", "}"], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'text-placeholder'), function (props) {
  return props.hasError && (0, _styledComponents.css)(["", ""], _kDsFoundation["default"].setColorTokenWithFallback('color: ', 'error'));
});
var RadioB2C = exports.RadioB2C = function RadioB2C(_ref) {
  var className = _ref.className,
    name = _ref.name,
    form = _ref.form,
    label = _ref.label,
    options = _ref.options,
    disabled = _ref.disabled,
    errorMessage = _ref.errorMessage,
    optional = _ref.optional,
    helper = _ref.helper,
    required = _ref.required,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  var optionsData = options.map(function (option) {
    var id = option.text.toLowerCase().replace(/ /g, '_');
    id = "".concat(name || '', "_").concat(id);
    return {
      id: id,
      text: option.text,
      value: option.value
    };
  });
  var hasError = Boolean(errorMessage);
  var labelOrRequired = /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "small",
    justify: "space-between",
    className: "k-ds-width-full",
    direction: "horizontal"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "k-ds-heading-02 k-ds-text-color-primary"
  }, label, required ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-text-color-error"
  }, ' *') : null), /*#__PURE__*/_react["default"].createElement("span", {
    className: "k-ds-label-01 k-ds-text-color-interactive-secondary"
  }, optional));
  return /*#__PURE__*/_react["default"].createElement(_index.Space, {
    size: "small",
    direction: "vertical",
    className: className
  }, label || required ? labelOrRequired : null, /*#__PURE__*/_react["default"].createElement(InputWrapper, {
    className: "k-ds-width-full",
    hasError: hasError
  }, /*#__PURE__*/_react["default"].createElement(_index.Space, _extends({
    size: "medium",
    direction: "horizontal",
    className: "k-ds-width-full"
  }, moreProps), options.length > 0 ? optionsData.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(StyledRadioB2CDiv, {
      key: option.id,
      className: "option"
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "radio",
      id: option.id,
      name: name,
      value: option.value,
      form: form,
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("label", {
      htmlFor: option.id,
      className: "k-ds-heading-01",
      "aria-hidden": "true"
    }, option.text));
  }) : null), helper || hasError ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "helper-error k-ds-caption-01"
  }, errorMessage || helper) : null));
};